<router-outlet></router-outlet>
<div class="flex absolute items-center h-full" >
    <a href="https://printingwarehouses.com" style="margin-left:-12px;z-index:999;">
    <img src="./assets/images/side_strip.svg" style="width:75%;object-fit:contain;"/>
    <p style="margin:0px;color:white;font-size:12px;position:absolute;top:49%;left:-87px;width:max-content;rotate:z 90deg;font-family:'poppins',sasnserif;font-weight:bold;">Printing Warehouses of America<sup style="font-size:12px;font-weight:bold;">®</sup></p>
    </a>
</div>